
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PrivateAppointmentFormBase.html?raw';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';

import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import Edit from '../../../moreCore/UI/Edit/Edit';

import { PrivateAppointmentTypes } from "../../_loadingHelpers/PrivateAppointment";

class PrivateAppointmentFormBase extends compose(_StatefulSection) {
    templateString: any = template;

    private dateStartInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private dateEndInput: MdsLax<InstanceType<typeof DateTimeInput>>;
    private descriptionInput: MdsLax<InstanceType<typeof Edit>>;
    private noteInput: MdsLax<InstanceType<typeof Edit>>;

    private existingEntity: PrivateAppointmentTypes.PrivateAppointment_Base = null;

    afterSetData() {
        let data = this.sourceData as PrivateAppointmentTypes.PrivateAppointment_Base;

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;

        } else {
            this._onPrivilegesLoaded();
        }
    }

    onDirtyChange(currentState: boolean) {

    }

    _onChanged(key: string, value: any) {

    }

    private _onChanged_Description(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }

    private _onPrivilegesLoaded() {
        // alle Rechte des Entities sind jetzt geladen, d.h. wir können synchron auswerten
        // falls wir hier sind obwohl this.existingEntity leer ist, dann wird die Rolle gewöhnlich allgemeingültig abgefragt

        let handlePriv = this.hasUserRole("PrivateAppointment_Handle", null, this.existingEntity);
    }

    _onChanged_Dates(key: string, newDate: Date, oldDate?: Date) {
        let data = this.currentData as PrivateAppointmentTypes.PrivateAppointment_Base;

        let dateEnd = this.dateEndInput.getValue()?.date;
        let dateStart = this.dateStartInput.getValue()?.date;

        if (key == "date_start" && dateStart) {

            if (dateStart && oldDate && dateEnd) {
                let diff = dateStart.valueOf() - oldDate.valueOf();

                dateEnd = new Date(dateEnd.valueOf() + diff);
                this.dateEndInput.setValue(dateEnd);
            } else if (dateStart && !dateEnd) {
                this.dateEndInput.setValue(dateStart);
            }
        }

        else if (key == "date_end") {
            if (dateEnd && dateStart) {
                let diff = dateEnd.valueOf() - dateStart.valueOf();

                if (diff < 0) {
                    // Ende liegt vor Start. darf nicht sein.
                    this.dateEndInput.setValue(dateStart);
                }
            }

            if (!dateStart) {
                this.dateStartInput.setValue(dateEnd);
            }
        }
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.addOnchanged("date_start", lang.hitch(this, this._onChanged_Dates));
        this.addOnchanged("date_end", lang.hitch(this, this._onChanged_Dates));
        this.addOnchanged("description", lang.hitch(this, this._onChanged_Description));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(PrivateAppointmentFormBase);